import {useState} from 'react'
import BillOfExchangeForm from './BillOfExchangeForm';
import BillOfExchangeList from './BillOfExchangeList';

const BillOfExchange = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <BillOfExchangeForm addForm={setFromIsShown} update={upData} />
        ) : (
          <BillOfExchangeList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default BillOfExchange